import { IRatingMatrixKind } from '__generated__';

export const MATRIX_KIND_LABEL_KEYS = {
  [IRatingMatrixKind.Value0]: 'frameworks-list-kind-standard',
  [IRatingMatrixKind.Value1]: 'frameworks-list-kind-banks',
  [IRatingMatrixKind.Value2]: 'frameworks-list-kind-insurance',
  [IRatingMatrixKind.Value3]: 'frameworks-list-kind-credit-insurance',
} as const satisfies Record<IRatingMatrixKind, string>;

export const MATRIX_KIND_OPTIONS: IRatingMatrixKind[] = [
  IRatingMatrixKind.Value0,
  IRatingMatrixKind.Value1,
  IRatingMatrixKind.Value2,
  IRatingMatrixKind.Value3,
];

/** Select option id for CommonSelect (avoids falsy 0). */
export function matrixKindSelectId(
  kind: IRatingMatrixKind | null | undefined,
): '0' | '1' | '2' | '3' {
  return String(normalizeMatrixKind(kind)) as '0' | '1' | '2' | '3';
}

export function parseMatrixKindSelectId(
  value: string | number | null | undefined,
): IRatingMatrixKind {
  if (value === '' || value == null) {
    return IRatingMatrixKind.Value0;
  }

  return normalizeMatrixKind(Number(value) as IRatingMatrixKind);
}

export function normalizeMatrixKind(
  kind: IRatingMatrixKind | number | null | undefined,
): IRatingMatrixKind {
  if (
    kind === IRatingMatrixKind.Value1 ||
    kind === IRatingMatrixKind.Value2 ||
    kind === IRatingMatrixKind.Value3
  ) {
    return kind;
  }

  return IRatingMatrixKind.Value0;
}

export function isSpecialMatrixKind(kind: IRatingMatrixKind | null | undefined): boolean {
  return normalizeMatrixKind(kind) !== IRatingMatrixKind.Value0;
}

export function getMatrixKindLabelKey(kind: IRatingMatrixKind | null | undefined): string {
  return MATRIX_KIND_LABEL_KEYS[normalizeMatrixKind(kind)];
}
